export default __webpack_public_path__ + "Delivery_W_Bd.woff";